import React from "react";
import { RouterProvider } from "react-router-dom";
import { adminRouter } from "./routes/adminRoutes";
import { customerRouter } from "./routes/customerRoutes";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from './util/admin/httpAdmin.js';
import ErrorBoundary from './components/shared/ErrorBoundary';

const getRouter = () => {
    const path = window.location.pathname.split("/")[1]; // Pak eerste segment na "/"
    
    // Lijst van paden die door de adminRouter moeten worden afgehandeld
    const adminPaths = [
        "dashboard", 
        "", 
        "inloggen", 
        "registreren", 
        "logout", 
        "algemene-voorwaarden", 
        "privacy", 
        "contact"
    ];
    
    return adminPaths.includes(path) ? adminRouter : customerRouter;
};

const App = () => {
    const router = getRouter(); // Dynamische router selectie

    return (
        <ErrorBoundary>
            <QueryClientProvider client={queryClient}>
                <RouterProvider router={router} />
            </QueryClientProvider>
        </ErrorBoundary>
    );
};

export default App;
